import { render, staticRenderFns } from "./technos.vue?vue&type=template&id=46db463e&"
import script from "./technos.vue?vue&type=script&lang=js&"
export * from "./technos.vue?vue&type=script&lang=js&"
import style0 from "./technos.vue?vue&type=style&index=0&id=46db463e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports